import { gql } from 'graphql-tag';

export const companyRelationshipsListQuery = gql`
  query CompanyRelationshipsList($limit: Int, $cursor: String, $companyId: String!) {
    companyRelationships(first: $limit, after: $cursor, companyId: $companyId) {
      edges {
        node {
          companyRelationshipId
          relationIdentifiers {
            companyIdentifierId
            identifierValue
            source
          }
          sourceCompany {
            company_name
            company_id
            signupVisibilitySources {
              status
              type
            }
            signupVisibilitySourcesViaSubcarriers {
              status
              type
            }
            unifiedSignupEvents {
              type
              eventTime
              visibilitySource
            }
          }
          targetCompany {
            company_name
            company_id
          }
          relationshipType
          companyGroupCopiedFrom {
            copiedAt
            company {
              company_name
              company_id
            }
          }
          origins {
            type
            originId
            createdAt
          }
          unifiedSignupStatus
          unifiedSignupEvents {
            type
            eventTime
            triggeredByUser {
              first_name
              last_name
              user_id
            }
          }
          dataSharingConsent {
            tourStatusScope
            history {
              consentSource
              tourStatusScope
              updatedByUser {
                first_name
                last_name
                user_id
              }
              updatedAt
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const carrierRelationshipInAccountQuery = gql`
  query CarrierRelationshipInAccount(
    $sourceCompanyId: String!
    $targetCompanyId: String!
    $relationshipType: CompanyRelationshipType!
  ) {
    companyRelationships(
      first: 1
      sourceCompanyId: $sourceCompanyId
      targetCompanyId: $targetCompanyId
      relationshipType: $relationshipType
    ) {
      edges {
        node {
          companyRelationshipId
        }
      }
    }
  }
`;
